import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check_oval_b",
  "use": "icon-check_oval_b-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\" id=\"icon-check_oval_b\">\n    <circle cx=\"13\" cy=\"13\" r=\"13\" fill=\"#0082BA\" />\n    <path stroke=\"#fff\" stroke-width=\"1.543\" d=\"M7 12.77L11.235 18 19 7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol